var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.666666666666668,26.666666666666668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#61c38b"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.3s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.33333333333333,26.666666666666668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#82d2a4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.2s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.666666666666668,73.33333333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#aedac1"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "0s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.33333333333333,73.33333333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#a6c3b3"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.1s"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.056452d8ff0bb44bfd0851e4b2bfdc51.svg";
export { ForwardRef as ReactComponent };